define.alias("ember-truth-helpers/helpers/is-empty", "media/helpers/is-empty");